"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AI_PROVIDER_WATCHED_COMPONENTS = exports.AI_PROVIDER_LATENCY_LIMITS_MS = void 0;
/** Per-provider latency thresholds for the "degraded" signal (ms). */
exports.AI_PROVIDER_LATENCY_LIMITS_MS = {
    elevenlabs: 2000,
    openai: 4000,
    mistral: 4000,
    'france-travail': 1500,
    gladia: 2000,
    gradium: 2000,
};
/** Status page components we actually consume per provider. */
exports.AI_PROVIDER_WATCHED_COMPONENTS = {
    elevenlabs: ['Text to Speech', 'Conversations', 'Quality', 'Speech to Text'],
    openai: ['Chat Completions', 'Responses'],
    mistral: ['Mistral', 'Mistral Data Website'],
    gradium: ['Realtime API - Europe', 'Realtime API - US East', 'Voice Cloning'],
};
